class Watch {
    constructor () {
      this.obj = {}
    }
    $emit(key, msg){//发布
        let arr = this.obj[key];
        if(arr&&arr.length>0){
          for(let i=0;i<arr.length;i++){
            arr[i](msg)
          }
        }
    }
    $on(key,cb){//订阅
      if(this.obj[key]){
        this.obj[key].push(cb)
      }else{
        this.obj[key] = [cb]
      }
    }
}
export  default new Watch();



// WEBPACK FOOTER //
// ./src/api/Bus.js